import React from "react";
import { classNames } from "../../helpers";

export default function TwAppBarIconButton(props) {
  const { children, srTitle, className = "", textClassName = "" } = props

  return (
    <button
      type="button"
      className={classNames("[-m-2.5] p-1.5 md:p-1.5 text-gray-400 hover:text-gray-500 rounded-full border border-gray-300", className)}
      onClick={props?.onClick ? props.onClick : () => { }}
    >
      <span className="sr-only">{srTitle}</span>
      {props.iconName && (<props.iconName aria-hidden="true" className="xs:size-5 sm:size-5 md:size-7 2xl:size-7" />)}
      {children}
    </button>
  );
}
